import React from 'react';
import classNames from 'classnames';

import { GatewayStatus } from 'views/Gateways/Gateways';

import styles from 'assets/scss/modules/Gateways/Gateways.module.scss';

interface Props {
  status: GatewayStatus;
}

const LABELS: Record<GatewayStatus, string> = {
  online: 'Online',
  offline: 'Offline',
  never_seen: 'Never seen',
};

export const StatusBadge: React.FC<Props> = ({ status }) => (
  <span
    className={classNames(styles.statusBadge, {
      [styles.statusBadgeOnline]: status === 'online',
      [styles.statusBadgeOffline]: status === 'offline',
      [styles.statusBadgeNeverSeen]: status === 'never_seen',
    })}
  >
    {LABELS[status]}
  </span>
);
